import jwt_decode from "jwt-decode";

(() => {
  if (window.token) {
    for (let tkey in window.token)
      if (window.token[tkey])
        window.token[tkey] = window.token[tkey].split("").reverse().join("");
    let tk = [window.token["f"], window.token["m"], window.token["l"]].join(
      "."
    );
    let decodedTK = jwt_decode(tk);
    window.env = decodedTK;
  }
  if (!window.env) window.env = {};
  if (window.env.PREFIX && !window.env.REACT_APP_PREFIX) {
    window.env.REACT_APP_PREFIX = window.env.PREFIX;
  }
  for (const envKey in process.env) {
    // Preserve explicit runtime false for these optional features.
    if (envKey === "REACT_APP_SHOW_LOTTO_DREAM" || envKey === "REACT_APP_SHOW_TOP_RANKING"
      ? window.env[envKey] === undefined || window.env[envKey] === null
      : !window.env[envKey]) window.env[envKey] = process.env[envKey];
  }
  window.env.modal_bg_header = `
  .modal_modal_bg_v2>div>.modal-content>.modal-header{
    background: ${
      window.env.REACT_APP_BG_MODAL_HEADER
        ? window.env.REACT_APP_BG_MODAL_HEADER
        : "linear-gradient(to right, #5099F2, #2F33B7)"
    };
    border: ${
      window.env.REACT_APP_BORDER_MODAL_HEADER
        ? window.env.REACT_APP_BORDER_MODAL_HEADER
        : ""
    };
  }
    .modal_modal_bg_v2>div>.modal-content>.modal-body{
    background: ${
      window.env.REACT_APP_BG_MODAL_BODY
        ? window.env.REACT_APP_BG_MODAL_BODY
        : ""
    };
  }
  .modal{
    padding-left: 0px !important;
  }
  `;
})();
